import type { ReactNode } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import './CollapsibleSection.css';

const BORDER_COLORS: Record<string, string> = {
  green: '#22c55e',
  orange: '#f97316',
  red: '#ef4444',
  purple: '#a855f7',
};

interface CollapsibleSectionProps {
  title: string;
  count: number;
  colorClass: 'green' | 'orange' | 'red' | 'purple';
  isExpanded: boolean;
  onToggle: () => void;
  subtitle?: string;
  children: ReactNode;
}

export default function CollapsibleSection({
  title,
  count,
  colorClass,
  isExpanded,
  onToggle,
  subtitle,
  children,
}: Readonly<CollapsibleSectionProps>) {
  const borderColor = BORDER_COLORS[colorClass];

  return (
    <div className="collapsible-section">
      <button
        type="button"
        className="collapsible-header"
        /* Dynamic border color based on severity prop — cannot use static Tailwind class */
        style={{ borderLeft: `4px solid ${borderColor}` }}
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        {isExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        <span>
          {title} <span className="collapsible-count">({count})</span>
        </span>
        {subtitle && <span className="collapsible-subtitle">{subtitle}</span>}
      </button>
      {isExpanded && <div className="collapsible-body">{children}</div>}
    </div>
  );
}
